import Vue from "vue";
import Vuex from "vuex";
import config from "../config";
import style from "./style";

Vue.use(Vuex);

const readStoredJson = (key) => {
  const value = localStorage.getItem(key);
  return value !== null ? JSON.parse(value) : null;
};

export default new Vuex.Store({
  state: {
    isRTL: config.isRTL,
    dark: localStorage.getItem("dark") == "true",
    // Global "request in flight" flag (see the HTTP interceptors and the views).
    loading: false,
    userName: localStorage.getItem("userName"),
    userData: readStoredJson("userData"),
    snackbar: false,
    snackbarMessage: "",
    snackbarColor: "",
  },
  mutations: {
    UPDATE_SNACKBAR(state, val) {
      state.snackbar = val;
    },

    /** Sets the message (and opens the snackbar unless it is empty); also accepts a bare string. */
    UPDATE_SNACKBAR_MESSAGE(state, payload) {
      const { message = "", color = "error" } = typeof payload == "string" ? { message: payload } : payload || {};
      state.snackbarMessage = message;
      state.snackbarColor = color;

      if (message != "") {
        state.snackbar = true;
      }
    },
    UPDATE_RTL(state, val) {
      state.isRTL = val;
    },
    UPDATE_DARK(state, val) {
      localStorage.setItem("dark", val);
      state.dark = val;
    },
    setLoading(state, val) {
      state.loading = val;
    },
    /** Stores the logged-in user; `null` logs out (everything but the last visited page is wiped). */
    setUserData(state, val) {
      state.userData = val;
      if (val == null) {
        const page = localStorage.getItem("page");
        localStorage.clear();
        localStorage.setItem("page", page);
      } else {
        localStorage.setItem("userData", val.Id);
        localStorage.setItem("userName", val.DisplayName);
      }
    },
  },
  modules: {
    style,
  },
});
